/** Os desenhos dos Founder Packs: o selo do nick (a mesma forma do engine), a coroa do VIP e as moedas. */
const SELO_D = 'M-5-6h10v5c0 4-2.4 6.6-5 7.6C-2.6 5.6-5 3-5-1z';
const ESTRELA_D = 'M0-3.6l1 2.2 2.3.2-1.8 1.5.6 2.3L0 1.4l-2.1 1.2.6-2.3-1.8-1.5 2.3-.2z';
const COROA_D = 'M-6 4V-4l3 3.5L0-5l3 4.5L6-4v8z';

export function Selo({ metal, tam = 14 }: { metal: string; tam?: number }) {
  return (
    <svg className="lp-f-selo" width={tam * 12 / 14} height={tam} viewBox="-6.5 -7.5 13 15.5" aria-hidden="true">
      <path d={SELO_D} fill={metal} stroke="rgba(0,0,0,.85)" strokeWidth="1.6" strokeLinejoin="round" />
      <path d={ESTRELA_D} fill="rgba(0,0,0,.55)" />
    </svg>
  );
}

export function Coroa({ largura = 18 }: { largura?: number }) {
  return (
    <svg width={largura} height={largura * 13 / 16} viewBox="-7 -6 14 11" aria-hidden="true">
      <path d={COROA_D} fill="#e6c452" stroke="rgba(0,0,0,.85)" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

export function Moedas({ tam = 20 }: { tam?: number }) {
  return (
    <svg width={tam} height={tam} viewBox="0 0 24 24" aria-hidden="true">
      <ellipse cx="12" cy="16" rx="8" ry="3.4" fill="#a8861c" />
      <ellipse cx="12" cy="13" rx="8" ry="3.4" fill="#c9a227" />
      <ellipse cx="12" cy="10" rx="8" ry="3.4" fill="#e6c452" stroke="#8a6d14" />
    </svg>
  );
}
